import { NewsArticleGroup } from '@models/news-article-group';
import { patchState } from '@ngrx/signals';
import { NewsArticlesStore } from '../news-articles.store';

export const getNewsArticleFieldExpertsMethods = (injects: { store: NewsArticlesStore }) => {
  const { store } = injects;

  const addFieldExpertToGroupArticles = (group: NewsArticleGroup, fieldExpertId: string) => {
    const fieldExpert = group.fieldExperts.find(expert => expert.id === fieldExpertId);
    if (!fieldExpert) {
      return;
    }
    patchState(store, {
      selectedNewsArticle:
        store.selectedNewsArticle() && store.selectedNewsArticle()!.groupId === group.id
          ? { ...store.selectedNewsArticle()!, fieldExperts: [...store.selectedNewsArticle()!.fieldExperts, fieldExpert] }
          : store.selectedNewsArticle(),
      newsArticles: store
        .newsArticles()
        .map(article => (article.groupId === group.id ? { ...article, fieldExperts: [...article.fieldExperts, fieldExpert] } : article)),
      newsArticlesByCommunity: store
        .newsArticlesByCommunity()
        .map(article => (article.groupId === group.id ? { ...article, fieldExperts: [...article.fieldExperts, fieldExpert] } : article)),
    });
  };

  const removeFieldExpertFromGroupArticles = (group: NewsArticleGroup, fieldExpertId: string) => {
    patchState(store, {
      selectedNewsArticle:
        store.selectedNewsArticle() && store.selectedNewsArticle()!.groupId === group.id
          ? {
              ...store.selectedNewsArticle()!,
              fieldExperts: store.selectedNewsArticle()!.fieldExperts.filter(expert => expert.id !== fieldExpertId),
            }
          : store.selectedNewsArticle(),
      newsArticles: store
        .newsArticles()
        .map(article =>
          article.groupId === group.id
            ? { ...article, fieldExperts: article.fieldExperts.filter(expert => expert.id !== fieldExpertId) }
            : article,
        ),
      newsArticlesByCommunity: store
        .newsArticlesByCommunity()
        .map(article =>
          article.groupId === group.id
            ? { ...article, fieldExperts: article.fieldExperts.filter(expert => expert.id !== fieldExpertId) }
            : article,
        ),
    });
  };
  return {
    addFieldExpertToGroupArticles,
    removeFieldExpertFromGroupArticles,
  };
};

export interface NewsArticleFieldExpertsStoreType {
  readonly addFieldExpertToGroupArticles: (group: NewsArticleGroup, fieldExpertId: string) => void;
  readonly removeFieldExpertFromGroupArticles: (group: NewsArticleGroup, fieldExpertId: string) => void;
}
